<template>
  <custom-dialog width="600px" :title="model.title" :visible="visible" v-on="$listeners">
    <div class="dialog-body">
      <!-- 用户信息 -->
      <el-form :model="form" :rules="rules" ref="form">
        <el-row>
          <el-col :span="24">
            <el-form-item :label="$t('base_language_config_dialog.jian_lei_xing')">
              <el-select v-model="langKeyType" disabled :placeholder="$t('Common.com_please_select')">
                <el-option v-for="item in model.data.langKeyTypes" :key="item.id" :label="item.name" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('base_language_config_dialog.jian_ming_cheng')" prop="langKeyName">
              <el-input v-model="langKeyName" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('base_language_config_dialog.jian_dai_ma')" prop="langKeyCode">
              <el-input v-model="langKeyCode" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('base_language_config_dialog.xian_shi_zhi')" prop="dataValue">
              <el-input v-model="form.dataValue"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('base_language_config_dialog.jian_miao_shu')" prop="langKeyDesc">
              <el-input :rows="3" type="textarea" v-model="form.langKeyDesc"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="visible = false">{{ $t('Common.com_cancel') }}</el-button>
      <el-button type="primary" @click="saveLangConfig">{{ $t('Common.com_confirm') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins.js';

export default {
  mixins: [dialogMixins],
  data() {
    return {
      groupId: '',
      appTree: [],
      langKeyType: '',
      langKeyName: '',
      langKeyCode: '',
      form: {
        langKeyId: '',
        langCode: '',
        dataValue: '',
        langKeyDesc: '',
      },
    };
  },
  computed: {
    rules() {
      return {
        dataValue: [
          {
            required: true,
            message: this.$t('Common.com_required'),
          },
          { max: 200, message: this.$t('Common.com_rules_length_max', [200]), },
        ],
        langKeyDesc: { max: 500, message: this.$t('Common.com_rules_length_max', [500]), },
      };
    },
  },
  mounted() {
    this.initDialog();
  },
  methods: {
    // 初始化
    initDialog: function () {
      this.form.langCode = this.model.data.langKeyCode;
      if (this.model.type === 'edit') {
        this.langKeyType = `${this.model.data.row.langKeyType}`;
        this.langKeyName = this.model.data.row.langKeyName;
        this.langKeyCode = this.model.data.row.langKeyCode;
        this.form.langKeyId = this.model.data.row.langKeyId;
        this.form.dataValue = this.model.data.row.dataValue;
        this.form.langKeyDesc = this.model.data.row.langKeyDesc;
      }
    },
    // 确认保存
    saveLangConfig: function () {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        if (this.model.type === 'edit') {
          this.saveEditLang();
        }
      });
    },
    // 保存编辑分组
    saveEditLang: function () {
      this.$postJSON(apis.LanguageSetup, this.form).then(() => {
        this.$message({
          message: this.$t('Common.com_edit_success'),
          type: 'success',
        });
        this.visible = false;
        this.$emit('success');
      });
    },
  },
};
</script>

<style lang="scss"></style>
